import styled from 'styled-components';

import { COLORS, STYLES } from 'apps/web_forms/utils/constants';

export const StyledResourceContainer = styled.div`
  display: flex;
  align-items: center;

  .file-info {
    display: flex;
    align-items: center;
    padding: 0.25em;
    cursor: pointer;

    svg {
      width: 1.9em;
      height: 1.9em;

      text {
        font-family: 'Helvetica', 'Roboto';
      }
    }

    span {
      margin-left: 0.5em;
      margin-top: 0.2em;
      font-size: 0.95em;
      font-weight: 300;
      text-decoration: underline;
    }

    &.updateHighlight {
      border: ${STYLES.UpdateHighlight};
    }
  }

  .download-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid black;
    box-sizing: border-box;
    font-size: 18px;
    margin-left: 4em;
    width: 1.9em;
    height: 1.9em;
    background-color: ${COLORS.grey};
    border-radius: 0.55em;
    line-height: 0;

    button {
      border: none;
      background: transparent;
      line-height: 0;
    }

    svg {
      fill: white;
      width: 1.2em;
      height: 1.2em;
    }

    &.updateHighlight {
      border: ${STYLES.UpdateHighlight};
    }
  }

  .downloading-container {
    display: flex;
    align-items: center;
    height: 1.9em;
    width: 1.9em;
    margin-left: 4em;

    button {
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      background: transparent;
      line-height: 0;

      svg {
        height: 100%;
        width: 100%;
      }

      svg.close-icon {
        height: 1em;
        width: 1em;
        position: absolute;
        fill: red;
      }
    }
  }
`;
